import { MAT_NATIVE_DATE_FORMATS, MatDateFormats } from '@angular/material/core';

export const PW_DATE_FORMATS: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    dateInput: 'pw-date-input',
  },
};
